import { CryptoAsset } from '@/pages/Donation/types'
import { ICryptoCurrency, INetwork } from '@/pages/Donation/api/types'

const QUICK_CRYPTO_OPTIONS = [{ code: 'USDT', networkCode: 'TRX' }, { code: 'ETH' }, { code: 'BTC' }]

export const checkOptionSelected = (option: CryptoAsset, selectedAsset: CryptoAsset | null) => {
  if (!selectedAsset) {
    return false
  }

  return (
    option.code === selectedAsset.code &&
    (!selectedAsset.network || option.network?.code === selectedAsset.network.code)
  )
}

export const getCryptoAssetWithNetwork = (
  currency: ICryptoCurrency | null,
  networkCode?: string
): CryptoAsset | null => {
  if (!currency) {
    return null
  }
  let network: INetwork | null = null
  if (networkCode && currency.networks) {
    network = currency.networks.find(network => network.code === networkCode) ?? null
  }

  return {
    code: currency.code,
    name: currency.name,
    icon: currency.icon_url,
    crypto: currency.crypto,
    network: network ?? currency.networks?.[0] ?? null,
  }
}

export const getQuickCryptoOptions = (cryptoCurrencies: ICryptoCurrency[]): CryptoAsset[] => {
  return QUICK_CRYPTO_OPTIONS.map(quickOption => {
    const currency = cryptoCurrencies.find(currency => currency.code === quickOption.code)

    if (currency) {
      return getCryptoAssetWithNetwork(currency, quickOption?.networkCode)
    }
  }).filter(Boolean) as CryptoAsset[]
}
